import { prefix } from './testAutomation';

export const testIds = {
  toaster: {
    error: `${prefix}-toaster-error`,
    success: `${prefix}-toaster-success`,
  },
};

export const sharedToasterConfigs = {
  timeout: 3000,
  position: 'topCenter' as const,
  wrapperClass: 'toaster-center-wrapper',
};

export const errorToasterConfigs = {
  ...sharedToasterConfigs,
  id: testIds.toaster.error,
};

export const successToasterConfigs = {
  ...sharedToasterConfigs,
  id: testIds.toaster.success,
};
